import {Component, Input} from '@angular/core';

@Component({
    selector: 'bb-button-group',
    styles: [require('./button-group.component.scss')],
    template: require('./button-group.component.html')
})
export class ButtonGroupComponent {

    /**
     * The type of the button-group (left|right).
     * @type {string}
     */
    @Input() type = 'left';

    /**
     * If the button group should take the full width.
     * @type {boolean}
     */
    @Input() full = false;

}



// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./src/components/button-group/button-group.component.ts